import './MultifunctionalCards.css';
import React from 'react';
import { get, getPageThemeColors, getColorByTheme, canUseDOM } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import RouterLink from '../atoms/RouterLink';
import { usePageZoom } from '../../utils/hooks/usePageZoom';
export const MultifunctionalCards = _ref => {
  let {
    fields,
    params,
    bannerSlideTitle = ''
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const links = get(fields, 'data.item.cards.targetItems') || [];
  const {
    zoomLevel,
    zoomedDPR
  } = usePageZoom(400);
  const zoomBreakPoint = zoomedDPR;
  const defaultItem = {
    id: get(fields, 'data.item.id') || '',
    name: get(fields, 'data.item.name') || '',
    path: get(fields, 'data.item.path') || '',
    template: {
      name: get(fields, 'data.item.template.name') || ''
    },
    svgIcon: {
      targetItem: {
        id: get(fields, 'data.item.svgIcon.targetItem.value.id') || '',
        name: get(fields, 'data.item.svgIcon.targetItem.value.name') || '',
        path: get(fields, 'data.item.svgIcon.targetItem.value.path') || '',
        image: get(fields, 'data.item.svgIcon.targetItem.value.image') || '',
        svg: {
          jss: {
            value: get(fields, 'data.item.svgIcon.targetItem.svg.jss.value') || ''
          }
        }
      }
    },
    title: {
      jss: {
        value: get(fields, 'data.item.title.jss.value') || ''
      }
    },
    shortDescription: {
      jss: {
        value: get(fields, 'data.item.shortDescription.jss.value') || ''
      }
    },
    link: {
      jss: {
        value: {
          href: get(fields, 'data.item.link.jss.value.href') || '',
          text: get(fields, 'data.item.link.jss.value.text') || '',
          anchor: get(fields, 'data.item.link.jss.value.anchor') || '',
          linktype: get(fields, 'data.item.link.jss.value.linktype') || '',
          class: get(fields, 'data.item.link.jss.value.class') || '',
          title: get(fields, 'data.item.link.jss.value.title') || '',
          querystring: get(fields, 'data.item.link.jss.value.querystring') || '',
          id: get(fields, 'data.item.link.jss.value.id') || ''
        }
      }
    },
    linkAnalytics: {
      jss: {
        value: get(fields, 'data.item.linkAnalytics.jss.value.') || ''
      }
    }
  };
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
    if (links) {
      links.push(defaultItem);
    }
  }, []);
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const variables = BackgroundColorHex ? {
    '--m113-MultifunctionalCards-background-color': BackgroundColorHex,
    '--m113-MultifunctionalCards-background-active-color': ActiveColorHex,
    '--m113-MultifunctionalCards-color': ColorHex
  } : {
    '--m113-MultifunctionalCards-background-color': selectedPrimaryColor,
    '--m113-MultifunctionalCards-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m113-MultifunctionalCards-color': getColorByTheme(selectedPrimaryColor)
  };
  if (!get(fields, 'data.item')) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  if (!fields) {
    console.info('MultifunctionalCards component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [MultifunctionalCards component is empty: please provide data source]");
    }
    return null;
  }
  const renderLinks = () => {
    if (links && links.length) {
      return links.map((el, index) => {
        const id = get(el, 'id');
        const title = get(el, 'title.jss.value');
        const desc = get(el, 'shortDescription.jss.value');
        const icon = get(el, 'svgIcon.targetItem.svg.jss.value');
        const linkHref = get(el, 'link.jss.value.href');
        const isLastItem = index + 1 === links.length;
        return /*#__PURE__*/React.createElement(RouterLink, {
          className: `m113-card ${isLastItem ? ' m113-card--last' : ''}`,
          href: linkHref,
          key: id,
          onClick: () => {
            tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['cardsClickAnalytics'], params), [title, bannerSlideTitle]);
          },
          dataCy: "multifunctional-card-link",
          linktype: "external",
          openInSameTab: true
        }, icon ? /*#__PURE__*/React.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: icon
          },
          className: "icon"
        }) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement("span", {
          className: "m113-card__title"
        }, title), /*#__PURE__*/React.createElement("p", {
          className: "m113-card__text"
        }, isLastItem ? /*#__PURE__*/React.createElement("svg", {
          width: "21",
          height: "21",
          className: "m113-card__last-icon",
          viewBox: "0 0 21 21",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M10.884 20.2241C9.5032 20.2241 8.20286 19.9594 6.98296 19.4299C5.76977 18.907 4.69733 18.1831 3.76565 17.2582C2.84067 16.3265 2.11342 15.254 1.58391 14.0409C1.06109 12.821 0.799686 11.5206 0.799686 10.1399C0.799686 8.75909 1.06109 7.46211 1.58391 6.24892C2.11342 5.02902 2.84067 3.95658 3.76565 3.0316C4.69063 2.09992 5.75971 1.37267 6.97291 0.849858C8.19281 0.320342 9.49314 0.0555835 10.8739 0.0555835C12.2547 0.0555835 13.555 0.320342 14.7749 0.849858C15.9948 1.37267 17.0672 2.09992 17.9922 3.0316C18.9172 3.95658 19.6444 5.02902 20.174 6.24892C20.7035 7.46211 20.9682 8.75909 20.9682 10.1399C20.9682 11.5206 20.7035 12.821 20.174 14.0409C19.6444 15.254 18.9172 16.3265 17.9922 17.2582C17.0672 18.1831 15.9948 18.907 14.7749 19.4299C13.5617 19.9594 12.2647 20.2241 10.884 20.2241ZM10.884 18.9272C12.0972 18.9272 13.2333 18.6993 14.2923 18.2435C15.358 17.7877 16.2931 17.1576 17.0974 16.3533C17.9084 15.549 18.5385 14.6173 18.9876 13.5583C19.4434 12.4925 19.6713 11.3531 19.6713 10.1399C19.6713 8.92666 19.4434 7.79055 18.9876 6.73151C18.5318 5.66578 17.9017 4.73075 17.0974 3.92642C16.2931 3.11538 15.358 2.48533 14.2923 2.03624C13.2333 1.58046 12.0938 1.35256 10.8739 1.35256C9.66071 1.35256 8.52124 1.58046 7.45551 2.03624C6.39647 2.48533 5.46479 3.11538 4.66046 3.92642C3.86284 4.73075 3.23613 5.66578 2.78035 6.73151C2.33126 7.79055 2.10672 8.92666 2.10672 10.1399C2.10672 11.3531 2.33126 12.4925 2.78035 13.5583C3.23613 14.6173 3.86619 15.549 4.67052 16.3533C5.47485 17.1576 6.40653 17.7877 7.46556 18.2435C8.52459 18.6993 9.66406 18.9272 10.884 18.9272ZM16.0417 10.1197C16.0417 10.2739 15.968 10.4214 15.8205 10.5621L12.2413 14.1514C12.134 14.2654 11.9966 14.3224 11.829 14.3224C11.6749 14.3224 11.5442 14.2687 11.4369 14.1615C11.3297 14.0476 11.2761 13.9135 11.2761 13.7593C11.2761 13.5918 11.3397 13.451 11.4671 13.3371L13.0456 11.7686L14.2923 10.6426L12.4323 10.7029H6.26912C6.10155 10.7029 5.9608 10.6493 5.84685 10.542C5.73961 10.4281 5.68598 10.2873 5.68598 10.1197C5.68598 9.95218 5.73961 9.81142 5.84685 9.69748C5.9608 9.58353 6.10155 9.52656 6.26912 9.52656H12.4323L14.2822 9.59694L13.0456 8.47087L11.4671 6.90243C11.3397 6.77508 11.2761 6.63432 11.2761 6.48016C11.2761 6.31929 11.3297 6.18859 11.4369 6.08805C11.5442 5.98081 11.6749 5.92718 11.829 5.92718C11.9966 5.92718 12.134 5.98081 12.2413 6.08805L15.8205 9.66731C15.968 9.81477 16.0417 9.96559 16.0417 10.1197Z",
          fill: "currentColor"
        })) : desc));
      });
    }
    return /*#__PURE__*/React.createElement("div", null);
  };
  const renderCarousel = () => {
    return /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
      let {
        renderCarousel,
        renderPreviousButton,
        renderNextButton,
        renderDots,
        state
      } = _ref2;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: ``
      }, renderCarousel(renderLinks(), {
        responsive: {
          desktop: {
            breakpoint: {
              max: 10000,
              min: 1200
            },
            items: 5
          },
          tabletLarge: {
            breakpoint: {
              max: 1199,
              min: 768
            },
            items: 3,
            partialVisibilityGutter: 20
          },
          tablet: {
            breakpoint: {
              max: 767,
              min: 480
            },
            items: 2,
            partialVisibilityGutter: 20
          },
          mobile: {
            breakpoint: {
              max: 479,
              min: 0
            },
            items: 1,
            partialVisibilityGutter: 150
          }
        },
        containerClass: '',
        partialVisible: true
      })));
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: `m113-mult-card ${zoomLevel >= zoomBreakPoint ? 'zoomed' : ''}`,
    style: variables
  }, zoomLevel >= zoomBreakPoint ? renderLinks() : renderCarousel()));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref3;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: ` ${commonStyles}  ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "c1aw31jo";
const ltrStyles = "l1p6kj0k";
const rtlStyles = "r16pcj7j";
export default MultifunctionalCards;